import cartonomyConfig from './cartonomy_config';
import aboutModule from '../modules/about/index';
import sharedModule from '../modules/shared/index';
import cartModule from '../modules/cart/index';
import orderModule from '../modules/order/index';
import profileModule from '../modules/profile/index';
import catalogModule from '../modules/catalog/index';

import angular from 'angular';
import angularAnimate from 'angular-animate';
import angularCookies from 'angular-cookies';
import angularMaterial from 'angular-material';
import angularMessages from 'angular-messages';
import angularMoment from 'angular-moment';
import angularResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import uiRouter from 'angular-ui-router';
import uiMask from 'angular-ui-mask';
import angularMarked from 'angular-marked';
import smartTable from 'angular-smart-table';
import ngMaterialDatePicker from 'ng-material-datetimepicker';
import angularTranslate from 'angular-translate';
import angularTranslateUrlLoader from 'angular-translate-loader-url';

import signalRModule from '../libs/angular-signalr-hub';

let dependencies = [
    angularResource,
    angularCookies,
    angularMaterial,
    smartTable,
    angularMessages,
    angularMoment,
    angularAnimate,
    ngSanitize,
    uiRouter,
    uiMask,
    angularMarked,
    signalRModule.name,
    ngMaterialDatePicker,
    angularTranslate,
    angularTranslateUrlLoader,

    // application modules
    aboutModule,
    sharedModule,
    cartModule,
    catalogModule,
    orderModule,
    profileModule
];

let module = angular.module('Cartonomy', dependencies);
module.config(['$mdThemingProvider', 'uiMask.ConfigProvider', '$qProvider', '$translateProvider',
    (themingProvider, uiMaskConfigProvider, $qProvider, $translateProvider) => {
        themingProvider.theme('default')
            .primaryPalette('blue')
            .accentPalette('grey');
        uiMaskConfigProvider.maskDefinitions({'9': /\d/, 'A': /[a-zA-Z]/, '*': /[a-zA-Z0-9]/, '2': /[2-9]/});
        uiMaskConfigProvider.clearOnBlur(false);
        uiMaskConfigProvider.eventsToHandle(['input', 'keyup', 'click']);

        $qProvider.errorOnUnhandledRejections(false);

        $translateProvider.useUrlLoader(`${cartonomyConfig.backendEndPoint}/api/locales`);
        $translateProvider.preferredLanguage('default');
    }]);

module.constant('cartonomyConfig', cartonomyConfig);

export default module;



// WEBPACK FOOTER //
// ./src/bootstrap/app.js